import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/modelos-documentos'

class ModeloDocumentoApiClient {
	async buscarModelosDocumentos(paginacao, filtros) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtros,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(URL)
	}

	async criarModeloDocumento(modeloDocumento) {
		return await axios.post(URL_PATH, modeloDocumento)
	}

	async buscarModelosDocumentosAtivos(filtro) {
		const URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/ativos`,
			filters: filtro,
		}).build()

		return await axios.get(URL)
	}

	async buscarModeloDocumentoPorId(idModelo) {
		return await axios.get(`${URL_PATH}/${idModelo}`)
	}

	async salvarEdicaoModeloDocumento(modeloDocumento) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${modeloDocumento.idModeloDocumento}`,
		}).build()

		return await axios.put(URL, modeloDocumento)
	}

	async redigir(idDocumento) {
		return await axios.put(`${URL_PATH}/${idDocumento}/redigir`)
	}

	async visualizarModelosDocumentos(idDocumento) {
		return await axios.get(`${URL_PATH}/${idDocumento}/visualizar`)
	}

	async excluirModeloDocumentoPorId(idModelo) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idModelo}`,
		}).build()
		return await axios.delete(url)
	}
}

export default new ModeloDocumentoApiClient()
